"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SoundBleep = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/esm/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/esm/createClass"));
var SoundBleep = exports.SoundBleep = /*#__PURE__*/function () {
  function SoundBleep() {
    (0, _classCallCheck2.default)(this, SoundBleep);
    this.audio = document.createElement('audio');
    var source = document.createElement('source');
    if (this.audio.canPlayType('audio/mpeg;')) {
      source.type = 'audio/mpeg';
      source.src = 'static/highlight.mp3';
    } else {
      source.type = 'audio/ogg';
      source.src = 'static/highlight.ogg';
    }
    this.audio.appendChild(source);
  }
  (0, _createClass2.default)(SoundBleep, [{
    key: "play",
    value: function play() {
      this.audio.play();
    }
  }]);
  return SoundBleep;
}();